<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>

<div mat-dialog-title class="modal-header header-radius-4">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div>
            <h4>Messages</h4>
        </div>
        <div>
            <button mat-dialog-close class="close close-btn" title="Close" type="button">
                <i class="fa fa-close"></i>
            </button>
        </div>
    </div>
</div>

<mat-dialog-content>
    <div class="p-0 mx-4 mb-4">
        <div class="row">
            <app-chat-list
                [accessingFrom]="'dialog'"
                [internalMemberList]="internalMemberList"
                [sRListGroupList]="sRListGroupList"
            ></app-chat-list>
            <app-message-panel [internalMemberList]="internalMemberList"></app-message-panel>
        </div>
    </div>
</mat-dialog-content>
